import { render, staticRenderFns } from "./cooperationDetail.vue?vue&type=template&id=13859d72&scoped=true"
import script from "./cooperationDetail.vue?vue&type=script&lang=js"
export * from "./cooperationDetail.vue?vue&type=script&lang=js"
import style0 from "./cooperationDetail.vue?vue&type=style&index=0&id=13859d72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13859d72",
  null
  
)

export default component.exports